// JsFromRoutes CacheKey d15bba55f8d605aac0a458c53f367349
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/order/confirmation/:order_number/:buyer_token/calendar_events'),
}
